<div class="single-select-popover">
  <div class="search-container">
    <ion-searchbar
      class="search"
      [placeholder]="searchPlaceholder | translate"
      mode="ios"
      color="light"
      (ionChange)="onSearch($event)"
    ></ion-searchbar>
  </div>
  <div class="single-select-popover__options-container">
    <ng-container *ngFor="let option of filteredPopoverInfo">
      <div (click)="onOptionChange(option)" class="single-select-popover__option">
        <span *ngIf="selectedOption" class="single-select-popover__checkbox">
          <ion-checkbox mode="ios" [checked]="selectedOption && option.value === selectedOption.value"></ion-checkbox>
        </span>
        <span class="single-select-popover__name">{{ option.displayName.toString() | translate }}</span>
      </div>
    </ng-container>
  </div>
</div>
